import { render, staticRenderFns } from "./GestionCandidatosBolson.vue?vue&type=template&id=2a7f72bc&scoped=true"
import script from "./GestionCandidatosBolson.vue?vue&type=script&lang=js"
export * from "./GestionCandidatosBolson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f72bc",
  null
  
)

export default component.exports